// extracted by mini-css-extract-plugin
module.exports = {"boxStyle":"Privacy_boxStyle__1t95Q","textStyle":"Privacy_textStyle__3lFXf","text":"Privacy_text__1htZX"};